import React from 'react';
import { Modal, Button, Form, Divider } from 'antd';
import { _success, _setAxios } from '../../../../lib/Helper';
import SelectTahunAjaran from '../../../../components/select/SelectTahunAjaran';
import { SelectTingkatanKelas } from 'components/select';

class Export extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            values: {},
        };
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        });
        _setAxios("keuangan/pemasukan/master/ekspor", "POST", {
            tahun_ajaran_id: this.state.values.tahun_ajaran_id ? this.state.values.tahun_ajaran_id : null,
            tingkatan_kelas: this.state.values.tingkatan_kelas ? this.state.values.tingkatan_kelas : null
        }).then(resp => {
            if (resp.status === true) {
                this.props.hideModal()
                _success('topRight', 'Success', resp.data.message)
                setTimeout(function () {
                    window.location.href = resp.data.data.link;
                }, 1000);
            }
            this.setState({
                loading: false
            });
        })
    };

    render() {
        return (
            <Modal
                title="Export data pemasukan"
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Batal</Button>
                    <Button type="primary" htmlType="submit" onClick={this.handleSubmit} loading={this.state.loading}>Export</Button>
                </>}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item label="Tahun Ajaran">
                        <SelectTahunAjaran
                            mode="multiple"
                            onChange={(val) => {
                                this.handleChangeSetValue("tahun_ajaran_id", val ? val : null)
                            }}
                        />
                    </Form.Item>
                    <Form.Item label="Tingkatan Kelas">
                        <SelectTingkatanKelas
                            mode="multiple"
                            onChange={(val) => {
                                this.handleChangeSetValue("tingkatan_kelas", val ? val : null)
                            }}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Divider />
                    <div style={{ textAlign: "left" }}>
                        Data yang diekspor akan langsung diunduh tanpa melalui log export. Apakah Anda yakin? </div>
                </Form>
            </Modal>
        )
    }
}

export default Export;
